import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TimeframeService } from '../../services/timeframe.service';
import { isEqual } from 'lodash-es';
import { TimeframeData } from '../../interfaces/TimeframeData';
import { AuthService } from '../../../auth/services/auth.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { MatOption, MatSelect } from '@angular/material/select';

@Component({
    selector: 'app-timeframe-selector',
    templateUrl: './timeframe-selector.component.html',
    styleUrls: ['./timeframe-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class TimeframeSelectorComponent implements OnInit {
    @Input() selectorPlaceholder = $localize`Date: No timeframe selected`;
    @Input() isGlobalSelector = true;
    @Output() timeframeChange: EventEmitter<TimeframeData | null> = new EventEmitter<TimeframeData | null>();

    public timeframesDataSource: TimeframeData[] = [
        {
            id: 1,
            name: '24h',
            label: 'Last 24 hours',
        },
        {
            id: 2,
            name: '7d',
            label: 'Last 7 days',
        },
        {
            id: 3,
            name: '30d',
            label: 'Last 30 days',
        },
    ];

    @ViewChild('timeframeSelector') timeframeSelector: MatSelect;
    @ViewChild('timeframeOption') timeframeOption: MatOption;

    private selectedTimeframe: TimeframeData | null;

    constructor(private timeframeService: TimeframeService, public authService: AuthService, private cdr: ChangeDetectorRef) {
        this.timeframeService.initializeSelectedTimeframe(this.SelectedTimeframe);
    }

    public get SelectedTimeframe(): TimeframeData | null {
        return this.selectedTimeframe;
    }

    public set SelectedTimeframe(timeframe: TimeframeData | null) {
        this.selectedTimeframe = timeframe || this.timeframesDataSource[0];

        if (timeframe) {
            this.timeframeService.selectTimeframe(timeframe);
        } else {
            this.timeframeService.selectTimeframe(this.timeframesDataSource[0]);
        }
    }

    public ngOnInit(): void {
        /* if a component other than this one changed the timeframe, update it, and emit the change */
        this.timeframeService
            .selectedTimeframe$()
            .pipe(distinctUntilChanged(isEqual))
            .subscribe({
                next: (timeframe: TimeframeData | null) => {
                    this.SelectedTimeframe = timeframe;
                    this.timeframeChange.emit(timeframe);
                    this.cdr.detectChanges();
                },
            });
    }

    public compareObjects(o1: any, o2: any): boolean {
        return o1.name === o2.name && o1.id === o2.id && o2.label === o2.label;
    }

    /**
     * Listen to selector opening
     * @param $event
     */
    public onSelectorOpenedChange($event: boolean) {
        /* check if selector has been opened (not closed) to reset viewport's properties */
        if (!$event) {
            return;
        }
    }

    public onKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            // this.selectorSearch.focus();
            this.timeframeSelector.open();
            setTimeout(() => {
                this.timeframeOption.focus();
            }, 0);
        }
    }
}
